module.exports = __webpack_public_path__ + "static/img/QRcode2.bad44ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/QRcode2.png
// module id = 3+El
// module chunks = 0